import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectBox = styled.div`
  cursor: pointer;
  padding: 8px;

  border-radius: 8px;
  background: ${({ theme }) =>
    theme.kallisto.color.background.static.backgroundPage};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  &:hover {
    outline: 3px solid
      ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  min-width: 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  max-width: 200px;
`;

export const Label = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.kallisto.color.text.static.textSecondary};
  margin-bottom: 2px;
`;

export const TruncatedText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Placeholder = styled.span`
  color: ${(props) => props.theme.kallisto.color.text.static.textSecondary};
`;

export const ArrowWrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  transition: transform 0.3s ease;
  transform: ${(props) => (props.$isOpen ? "rotate(0deg)" : "rotate(180deg)")};
`;

export const OptionsList = styled.ul<{ $isOpen: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  position: absolute;
  z-index: 1000;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  background: ${({ theme }) =>
    theme.kallisto.color.background.static.backgroundPage};
  border: 1px solid
    ${({ theme }) => theme.kallisto.color.border.static.borderNeutral};
  border-radius: 8px;
  margin: 4px 0;
  padding: 8px 0;
  box-shadow: ${({ theme }) => theme.commons.elevations.medium};
`;

export const OptionItem = styled.li`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.theme.kallisto.color.background.interactive.backgroundNeutralHover};
  }
`;

export const CheckboxWrapper = styled.div`
  pointer-events: none; // This ensures clicks pass through to the OptionItem
`;

export const ClearAllButton = styled.button`
  width: 100%;
  padding-left: 20px;
  padding-right: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  background-color: ${(props) =>
    props.theme.kallisto.color.background.static.backgroundPage};
  border: none;
  border-bottom: 1px solid
    ${(props) => props.theme.kallisto.color.border.static.borderNeutral};
  cursor: pointer;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: flex-start;
  color: ${(props) =>
    props.theme.kallisto.color.text.interactive.textPrimaryDefault};
  svg {
    fill: ${(props) =>
      props.theme.kallisto.color.text.interactive.textPrimaryDefault};
  }
  &:hover {
    background-color: ${(props) =>
      props.theme.kallisto.color.text.interactive.textPrimaryDefault};
    color: ${(props) =>
      props.theme.kallisto.color.background.static.backgroundPage};
    svg {
      fill: ${(props) =>
        props.theme.kallisto.color.background.static.backgroundPage};
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
`;

export const SearchValueInput = styled.input`
  border: 0px;
  padding: 0px;
  margin: 0;
  color: ${(props) => props.theme.kallisto.color.text.static.textPrimary};
  width: 100%;
  text-overflow: ellipsis;
  background: transparent;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;

  &:focus {
    outline: none;
  }
`;
